// 引入windi css
import '@/plugins/windi.css'

// 导入全局的svg图标
import '@/plugins/svgIcon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// iconfont
import '@/styles/icon-font/iconfont.css'

// 路由
import { setupRouter } from './router'

// 权限
import { setupPermission } from './directives'

import { createApp } from 'vue'

import App from './App.vue'

import './permission'

import print from 'vue3-print-nb'

import * as ElIconModules from '@element-plus/icons-vue'
// import { initIndexedDB } from './indexeddb'

// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  // await initIndexedDB()

  await setupI18n(app)

  setupStore(app)

  setupGlobCom(app)

  setupElementPlus(app)

  setupRouter(app)

  setupPermission(app)

  app.use(ElementPlus)
  app.use(print)
  
  Object.keys(ElIconModules).forEach(function (key) {
    app.component(ElIconModules[key].name, ElIconModules[key])
  })
  app.mount('#app')
}

setupAll()

Number.prototype.fixed = function(val=2) {
  const number = this
  if(number === null || number === undefined ||isNaN(number)) return ''
  if(isNaN(val)){
      val = 2 
  }
  return Number(number.toFixed(val))
}    
